import apiConfig from '../../config/api.config';

const isServer = typeof window === 'undefined';

const envs = (isServer: boolean) => {
  return {
    staticConfigUrl: isServer ? apiConfig.STATIC_CONFIG_URL_SERVER : apiConfig.STATIC_CONFIG_URL,
    feedApi: isServer ? apiConfig.FEED_API_URL_SERVER : apiConfig.FEED_API_URL,
    contentApiV3: isServer ? apiConfig.CONTENT_API_URL_V3_SERVER : apiConfig.CONTENT_API_URL_V3,
    commentFeUrl: apiConfig.COMMENT_FE_URL,
    customerDataApi: apiConfig.CUSTOMER_DATA_API_URL,
    mediaApi: isServer ? apiConfig.MEDIA_API_DATA_URL_SERVER : apiConfig.MEDIA_API_DATA_URL,
    mediaApiCropper: isServer ? apiConfig.MEDIA_API_URL_SERVER : apiConfig.MEDIA_API_URL,
    weatherApi: isServer ? apiConfig.WEATHER_API_URL_SERVER : apiConfig.WEATHER_API_URL,
    notificationApi: apiConfig.NOTIFICATION_API_URL,
  };
};

export function getEnv(envType: keyof ReturnType<typeof envs>) {
  return envs(isServer)[envType] || '';
}
